<div class="hx-search-typeahead__container" [class.hx-search-typeahead__container--error]="showError()">
  <div #searchInputContainer>
    <hx-input
      type="text"
      [label]="label()"
      [required]="required()"
      [labelFontWeight]="labelFontWeight()"
      [labelFontSize]="labelFontSize()"
      [subtitleFontWeight]="subtitleFontWeight()"
      [subtitleFontSize]="subtitleFontSize()"
      [labelColor]="labelColor()"
      [subtitleColor]="subtitleColor()"
      [placeholder]="placeholder()"
      [disabled]="disabledState()"
      [value]="searchInputValue()"
      [readonly]="readonly()"
      [startIcon]="showTags() ? 'search' : undefined"
      [endIcon]="showDropdownChevron() ? 'chevron-down' : undefined"
      [hideErrorMessage]="true"
      [tooltip]="tooltip()"
      [tooltipPosition]="tooltipPosition()"
      [tooltipColor]="tooltipColor()"
      (input)="onSearchInput($any($event.target).value)"
      (mousedown)="onInputMouseDown($event)"
      (focusin)="onInputFocus()"
      (keydown)="onKeyDown($event)"
      (focusout)="onBlur($event)"></hx-input>
    @if (showError()) {
      <div class="hx-search-typeahead__error-message">
        {{ searchErrorMessageDisplay() }}
      </div>
    }
  </div>

  @if (showTags() && localSelectedItems().length > 0) {
    <div class="hx-search-typeahead__tags-container">
      <div class="hx-search-typeahead__tags-list">
        @for (tag of visibleTags(); track tag.id) {
          <hx-tag
            [label]="tag.displayText"
            [removable]="!tag.locked"
            [disabled]="tag.locked"
            [attr.title]="tag.locked ? 'Added from ' + (tag.sourceType ?? 'external source') : null"
            (removed)="removeTag(tag)"
            variant="filled"
            [maxWidth]="undefined"
            [color]="tag.locked ? 'default' : 'primary'"></hx-tag>
        }
        @if (hiddenTagCount() > 0) {
          <button hxButton type="button" class="hx-search-typeahead__more-button" (click)="toggleTagExpansion()">
            +{{ hiddenTagCount() }}
          </button>
        }
      </div>
    </div>
  }
</div>

<!-- CDK Overlay Portal for Dropdown -->
<ng-template #dropdownPortal>
  @if (dropdownVisible()) {
    <div
      class="hx-search-typeahead__dropdown"
      role="listbox"
      aria-label="Search results"
      (scroll)="onDropdownScroll($event)">
      @if (isSearching()) {
        <div class="hx-search-typeahead__searching-state">Searching...</div>
      }

      @if (!isSearching() && hasResults()) {
        <div class="hx-search-typeahead__results-list">
          @for (item of filteredItems(); track getItemIdentity(item); let i = $index) {
            <button
              type="button"
              class="hx-search-typeahead__result-item"
              [class.hx-search-typeahead__result-item--highlighted]="i === highlightedIndex()"
              [class.hx-search-typeahead__result-item--multiselect]="multiple()"
              (mousedown)="$event.preventDefault()"
              (click)="selectItem(item)"
              role="option"
              [attr.aria-selected]="i === highlightedIndex()">
              @if (multiple()) {
                <span
                  class="hx-search-typeahead__result-checkbox"
                  [class.hx-search-typeahead__result-checkbox--checked]="isItemSelected(item)"
                  aria-hidden="true"></span>
              }
              <span class="hx-search-typeahead__result-primary" [innerHTML]="item.highlightedLabel"></span>
              @if (item.secondaryLabel) {
                <span class="hx-search-typeahead__result-secondary">{{ item.secondaryLabel }}</span>
              }
            </button>
          }
        </div>
      }

      @if (!isSearching() && showNoResults()) {
        <div class="hx-search-typeahead__empty-state">
          {{ noResultsMessage() }}
        </div>
      }

      @if (!isSearching() && showNoItems()) {
        <div class="hx-search-typeahead__empty-state">
          {{ noItemsMessage() }}
        </div>
      }

      @if (!isSearching() && loadingMore()) {
        <div class="hx-search-typeahead__searching-state">Loading more...</div>
      }
    </div>
  }
</ng-template>
